module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Partnership Program',
          to: {
            path: '/partnership-program'
          },
        },
        {
          text: _vm.form.id ?
            'Ubah Partnership Program' :
            'Tambah Partnership Program',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(_vm.form.id ?
    "Ubah Partnership Program" :
    "Tambah Partnership Program") + "\n    ")]), _vm._v(" "), _c('v-form', {
    ref: "form"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("\n                " + _vm._s(_vm.form.id ?
    "Ubah Partnership Program" :
    "Tambah Partnership Program") + "\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-2",
    staticStyle: {
      "min-width": "0 !important"
    },
    attrs: {
      "depressed": "",
      "rouded": "",
      "small": "",
      "height": "33px",
      "color": "#EC675E"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "color": "white"
    }
  }, [_vm._v("\n                        mdi-delete-outline\n                    ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [
    [_c('div', {
      staticClass: "mb-2 mt-4"
    }, [_c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("\n                                    Nama Program *\n                                ")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "placeholder": "Nama Program",
        "outlined": "",
        "rules": [
          function (v) { return !!v ||
          'Nama program wajib diisi'; } ],
        "required": ""
      },
      model: {
        value: (_vm.form.nama),
        callback: function($$v) {
          _vm.$set(_vm.form, "nama", $$v)
        },
        expression: "form.nama"
      }
    })], 1)], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("\n                                    Partnership Owner *\n                                ")]), _vm._v(" "), _c('v-autocomplete', {
      attrs: {
        "placeholder": "Pilih Owner",
        "items": _vm.data_owner,
        "outlined": "",
        "item-text": "nama",
        "item-value": "id",
        "rules": [
          function (v) { return !!v || 'Owner wajib diisi'; } ]
      },
      model: {
        value: (_vm.form.owner_id),
        callback: function($$v) {
          _vm.$set(_vm.form, "owner_id", $$v)
        },
        expression: "form.owner_id"
      }
    })], 1)], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("\n                                    Paket *\n                                ")]), _vm._v(" "), _c('v-autocomplete', {
      staticClass: "pa-0",
      attrs: {
        "placeholder": "Pilih Paket",
        "outlined": "",
        "items": _vm.data_package,
        "item-text": "name",
        "item-value": "id",
        "rules": [
          function (v) { return !!v || 'Paket wajib diisi'; } ]
      },
      model: {
        value: (_vm.form.package_id),
        callback: function($$v) {
          _vm.$set(_vm.form, "package_id", $$v)
        },
        expression: "form.package_id"
      }
    })], 1)], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("\n                                    Deskripsi *\n                                ")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "placeholder": "Deskripsi",
        "outlined": "",
        "maxlength": "255",
        "rules": [
          function (v) { return !!v || 'Deskripsi wajib diisi'; } ]
      },
      model: {
        value: (_vm.form.description),
        callback: function($$v) {
          _vm.$set(_vm.form, "description", $$v)
        },
        expression: "form.description"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-4"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "text": ""
      },
      on: {
        "click": function($event) {
          return _vm.$router.push('/partnership-program')
        }
      }
    }, [_vm._v("\n                            Batal\n                        ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary",
        "depressed": ""
      },
      on: {
        "click": function($event) {
          return _vm.submitProcess()
        }
      }
    }, [_vm._v("\n                            Simpan\n                        ")])], 1)]
  ], 2)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fe94950","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/partnership/components/PartnershipProgramForm.vue
// module id = 2199
// module chunks = 1